export const uk = {
    'clicks-forecast': 'Прогноз кликов',
    'cost-forecast': 'Прогноз расхода, {currency}',
    name: 'Площадка'
};
